var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"head"},[_c('div',{staticClass:"footerContent"},[_c('div',[_vm._v("主办单位：中国铁道工程建设协会 地址：北京市复兴路10号")]),_c('div',[_vm._v("邮编：100844 电话：(010)51847442 传真：(010)51847442 备案号：京ICP备13011762号-4")])])])
}]

export { render, staticRenderFns }